import { Injectable } from '@angular/core';
import { AbstractDataProvider } from '@epicuro-next/data-providers/base-data-provider';
import { ConfigurationsService } from '@epicuro-next/platform/configuration';
import { Observable, Subject } from 'rxjs';
import { shareReplay, takeUntil } from 'rxjs/operators';

@Injectable()
export class ConfigurationsProviderService implements AbstractDataProvider {
  private bindings = new Map<string, Observable<unknown>>();
  private destroy$ = new Subject<void>();

  constructor(private configurationService: ConfigurationsService) {}

  public read<T>({
    namespace,
    featureName,
    defaultValue,
  }: {
    namespace: string;
    featureName: string;
    defaultValue?: unknown;
  }) {
    const key = `${namespace}.${featureName}`;
    let observable = this.bindings.get(key);

    if (observable) {
      return observable as Observable<T>;
    }

    observable = this.configurationService
      .fetchConfigValue({
        namespace,
        featureName,
        defaultValue,
      })
      .pipe(
        shareReplay({ bufferSize: 1, refCount: true }),
        takeUntil(this.destroy$),
      );

    this.bindings.set(key, observable);

    return observable as Observable<T>;
  }

  public write() {
    // here for eslint
  }
}
